// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import AverageRateSection from "./AverageRateSection";
import SurveyTable from "./SurveyTable";
import SurveyAnswerDialog from "../../../components/SurveyAnswerDialog";
import CircularProgress from "../../../components/CircularProgress";

// MARK: Stores
import SurveyStore from "../../../stores/SurveyStore";

// MARK: Resources
import strings from "../../../resources/strings";

interface IProps {
	surveyStore: SurveyStore;
}

@inject("surveyStore")
@observer
export default class Surveys extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.surveyStore.getStats();
		await this.props.surveyStore.getSurveys();
	};

	public render() {
		const { surveyStore } = this.props;

		return (
			<div className="avaliations">
				<span className="avaliationsTitle">{strings.surveys.title}</span>
				{surveyStore.loading ?
					<CircularProgress /> :
					(surveyStore.surveyStats && surveyStore.surveyStats.questionStatsSections.length !== 0 ? (
						<>
							<AverageRateSection
								surveyStats={surveyStore.surveyStats}
							/>
							<SurveyTable
								surveyStore={surveyStore}
							/>
							<SurveyAnswerDialog
								surveyStore={surveyStore}
							/>
						</>
					) : (
							<div className="avaliationsIsEmpty">
								{strings.surveys.avaliationsIsEmpty}
							</div>
						)
					)
				}
			</div>
		);
	}
}
